"use strict";

require("core-js/modules/es.array.reduce.js");

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function wrapper(pid, command) {
  var options = command.options,
      _execute = command.execute;
  var spreadOpts = Object.entries(options).reduce(function (acc, _ref) {
    var _objectSpread2;

    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return _objectSpread({}, acc, (_objectSpread2 = {}, _defineProperty(_objectSpread2, key, val), _defineProperty(_objectSpread2, val.alias, _objectSpread({}, val, {
      alias: key
    })), _objectSpread2));
  }, {});

  var unifyOptions = function unifyOptions(rtOpts) {
    return Object.entries(rtOpts).reduce(function (acc, _ref3) {
      var _objectSpread3;

      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          val = _ref4[1];

      return _objectSpread({}, acc, (_objectSpread3 = {}, _defineProperty(_objectSpread3, key, val), _defineProperty(_objectSpread3, spreadOpts[key].alias, val), _objectSpread3));
    }, {});
  };

  var redistributeArgsOpts = function redistributeArgsOpts(args, opts) {
    var _Object$entries$reduc = Object.entries(opts).reduce(function (_ref5, _ref6) {
      var _ref7 = _slicedToArray(_ref5, 2),
          accArgs = _ref7[0],
          accOpts = _ref7[1];

      var _ref8 = _slicedToArray(_ref6, 2),
          optKey = _ref8[0],
          optVal = _ref8[1];

      if (!spreadOpts[optKey]) return [accArgs, accOpts];

      if (spreadOpts[optKey].type === 'boolean') {
        if (optVal) {
          accArgs = [].concat(_toConsumableArray(accArgs), [optVal]);
        }

        accOpts = _objectSpread({}, accOpts, _defineProperty({}, optKey, true));
      } else {
        accOpts = _objectSpread({}, accOpts, _defineProperty({}, optKey, optVal));
      }

      return [accArgs, accOpts];
    }, [[], {}]),
        _Object$entries$reduc2 = _slicedToArray(_Object$entries$reduc, 2),
        additionalArgs = _Object$entries$reduc2[0],
        distributedOpts = _Object$entries$reduc2[1];

    var redistributedOpts = unifyOptions(distributedOpts);
    var defaults = Object.entries(spreadOpts).reduce(function (acc, _ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          optKey = _ref10[0],
          optVal = _ref10[1];

      var defaultVal = optVal.default || optVal.type === 'boolean' && false;
      var deflt = !(0, _lodash.isNil)(defaultVal) ? _defineProperty({}, optKey, defaultVal) : {};
      return _objectSpread({}, acc, {}, deflt);
    }, {});
    return [[].concat(_toConsumableArray(additionalArgs), _toConsumableArray(args)), _objectSpread({}, defaults, {}, redistributedOpts)];
  };

  var executionContext = _objectSpread({}, command, {
    pid: pid
  });

  var metadata = {
    pid: pid
  };
  return {
    execute: function execute(args, opts) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _execute.call.apply(_execute, [executionContext].concat(_toConsumableArray(redistributeArgsOpts(args, opts)), [metadata]));

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
}

var _default = wrapper;
exports.default = _default;